<template>
	<div id="MyChit">
		<ul class="tab">
			<li
				v-for="tab in tabs"
				:key="tab.view"
				:class="[tab.view, { active: currentTab == tab.view }]"
			>
				{{ tab.type }}
			</li>
		</ul>
		<div id="ChitEffect">
			<!-- 保单生效 -->
			<div class="middle">
				<div class="plan">
					<ul>
						<li v-for="(order, i) in insuranceList" :key="i">
							<div class="one">
								<div class="left">
									{{
										HISTORY_PRODUCT_DATA[order.productCode]
											? HISTORY_PRODUCT_DATA[order.productCode].produceName
											: ''
									}}
								</div>
								<div class="right" @click="orderDetail(order.orderId)">
									订单详情
									<span>></span>
								</div>
							</div>
							<div class="two">
								<div class="left">
									<div class="top">保障起期</div>
									<div class="bottom">
										{{ dateExChange(order.effectiveStartDate) }}
									</div>
								</div>
								<div class="right">
									<div class="top">保障止期</div>
									<div class="bottom">
										{{
											order.effectiveEndDate
												? dateExChange(order.effectiveEndDate)
												: '终身'
										}}
									</div>
								</div>
							</div>
						</li>
					</ul>
				</div>
				<div class="introduce">用心承诺</div>
			</div>
		</div>
	</div>
</template>
<script>
import { Toast } from 'vant';
import http from '../../h5-network/request.js';
import HISTORY_PRODUCT_DATA from '@/enum/HISTORY_PRODUCT_DATA.js';
export default {
	data() {
		this.HISTORY_PRODUCT_DATA = HISTORY_PRODUCT_DATA;
		return {
			currentTab: 'ChitEffect',
			tabs: [{ type: '已完成', view: 'ChitEffect' }],
			insuranceList: [],
		};
	},
	created() {
		http({
			loading: true,
			url: '/bdzb-core-service/order/getPaySuccessOrderList',
			data: { orderStatus: 'EFFECT' },
			method: 'POST',
		})
			.then((data) => {
				this.insuranceList = data;
				console.log(this.insuranceList);
			})
			.catch((err) => {
				err.message && Toast(err.message);
			});
	},
	methods: {
		dateExChange(date) {
			return date;
		},
		orderDetail(id) {
			location.href = '#/order-info/' + id;
		},
	},
};
</script>

<style scoped>
#MyChit {
	min-height: 100vh;
	font-size: 0.13rem;
	background-color: #f6f6f6;
}
.header {
	width: 100%;
	height: 0.4rem;
	text-align: center;
	line-height: 0.4rem;
	color: #333;
	font-size: 0.16rem;
	border-bottom: 0.01rem solid #c8c9c8;
	padding: 0 0.25rem 0 0.15rem;
}
.header span {
	font-size: 0.24rem;
	float: left;
	margin-right: -0.5rem;
}
ul.tab {
	height: 0.4rm;
	padding: 0 0.05rem;
	display: flex;
	color: #666;
	background-color: #fff;
}
ul.tab li {
	display: inline-block;
	height: 0.4rem;
	flex: 1;
	text-align: center;
	line-height: 0.4rem;
}
ul.tab li.active {
	color: #0582c8;
	border-bottom: 0.01rem solid #0582c8;
}
ul.tab li.ChitConfirm {
	flex: 1.5;
}

#ChitEffect {
	font-size: 0.14rem;
	background-color: #f6f6f6;
}
.middle {
	background-color: #f6f6f6;
}
.middle .plan {
	padding: 0.1rem 0.1rem 0;
}
.middle .plan ul li {
	width: 100%;
	height: 1.1rem;
	margin-bottom: 0.1rem;
	margin-right: 0;
	background-color: #fff;
	border-radius: 0.02rem;
}
.middle .plan ul li .one {
	width: 100%;
	height: 0.45rem;
	line-height: 0.45rem;
}
.middle .plan ul li .one .left {
	float: left;
	margin-left: 0.1rem;
	font-size: 0.149rem;
	color: #333;
	font-weight: 600;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
	width: 2.3rem;
}
.middle .plan ul li .one .right {
	float: right;
	margin-right: 0.1rem;
	color: #0582c8;
	font-size: 0.1306rem;
}
.middle .plan ul li .one .right span {
	color: #666;
}
.middle .plan ul li .two {
	width: 100%;
	height: 0.65rem;
}
.middle .plan ul li .two .left {
	float: left;
	margin-left: 0.1rem;
}
.middle .plan ul li .two .left .top {
	margin-top: 0.05rem;
	color: #999;
	font-size: 0.0933rem;
}
.middle .plan ul li .two .left .bottom {
	margin-top: 0.03rem;
	color: #666;
}
.middle .plan ul li .two .right {
	float: right;
	margin-right: 0.1rem;
}
.middle .plan ul li .two .right .top {
	margin-top: 0.05rem;
	color: #999;
	font-size: 0.0933rem;
}
.middle .plan ul li .two .right .bottom {
	margin-top: 0.03rem;
	color: #666;
}
.introduce {
	font-size: 0.12rem;
	color: #b6b6b6;
	text-align: center;
}
</style>
